import { render, staticRenderFns } from "./apps-page.vue?vue&type=template&id=f122c032&scoped=true&lang=pug&"
import script from "./apps-page.vue?vue&type=script&lang=js&"
export * from "./apps-page.vue?vue&type=script&lang=js&"
import style0 from "./apps-page.vue?vue&type=style&index=0&id=f122c032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f122c032",
  null
  
)

export default component.exports